import { faTriangleExclamation } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'Components/Atoms/Button/Button';
import Container from 'Components/Atoms/Container/Container';
import Title from 'Components/Atoms/Title/Title';
import ButtonGroup from 'Components/Molecules/ButtonGroup/ButtonGroup';
import TitleGroup from 'Components/Molecules/TitleGroup/TitleGroup';
import { useState } from 'react';
import Modal from '../../Modal/Modal';
import ModalFooter from '../../ModalFooter/ModalFooter';
import ModalHeader from '../../ModalHeader/ModalHeader';

const DeletionModal = ({
    children,
    onClose, onDelete,
    isDeleting
}: Props) => {
    const [state, setState] = useState({
        isDeleting: false
    });

    const handleDelete = () => {
        setState({
            ...state,
            isDeleting: true
        });
        onDelete();
    }

    const handleClose = () => onClose();

    return <Modal size='small'>
        <ModalHeader size='small'>
            <TitleGroup
                iconBefore={
                    <FontAwesomeIcon
                        size='lg'
                        icon={faTriangleExclamation}
                        color={'#FF9800'}
                    />
                }
            >
                <Title
                    size='medium'
                    weight='bold'
                    color='warning'
                    transform="uppercase"
                >
                    Waarschuwing
                </Title>
            </TitleGroup>
        </ModalHeader>
        <Container padding='vertical'>
            {/* { children } */}
            Het verwijderen van de gegevens kan niet ongedaan gemaakt worden.
            <br/>
            Weet je zeker dat je door wilt gaan?
        </Container>
        <ModalFooter size='small'>
            <ButtonGroup>
                { !isDeleting && <Button
                    size='small'
                    variant='transparent'
                    color='warning'
                    onClick={handleClose}
                >
                    Annuleren
                </Button> }
                <Button
                    size='small' 
                    variant='solid'
                    color='warning'
                    isLoading={isDeleting}
                    onClick={handleDelete}
                >
                    Verwijderen
                </Button>
            </ButtonGroup>
        </ModalFooter>
    </Modal>;
}

interface Props {
    children?: any
    isDeleting?: boolean
    onClose: any
    onDelete: any
}

export default DeletionModal;